export const SWITCH_LANG = 'switchLanguage'
export const UPDATE_LANG = 'updateLanguage'
export const PUBLISH_LANG = 'updatePublishedLanguage'
export const PUBLISH_SINGLE_LANG = 'publishLanguage'
export const REPLACE_LANGUAGES = 'replaceLanguages'
export const RESET_LANGUAGES = 'resetLanguages'
export const SET_LANGUAGES = 'setLanguages'

export default {
  SWITCH_LANG,
  UPDATE_LANG,
  PUBLISH_LANG,
  PUBLISH_SINGLE_LANG,
  REPLACE_LANGUAGES,
  RESET_LANGUAGES,
  SET_LANGUAGES
}
